interface FinalCTAProps {
  headline?: string;
  subheadline?: string;
  ctaLabel?: string;
  ctaHref?: string;
}

export default function FinalCTA({
  headline = "Stay Cool — Even in Peak Texas Heat",
  subheadline = "Get fast, professional cooling service backed by certified technicians. Serving McKinney, Dallas, and the entire DFW metro.",
  ctaLabel = "Request Service Now",
  ctaHref = "#quote",
}: FinalCTAProps) {
  return (
    <section className="relative py-32 overflow-hidden">
      {/* Background */}
      <img
        src="https://public.readdy.ai/ai/img_res/4874b0995fab5181c1c39c6e6f378664.jpg"
        alt="Dallas Texas HVAC service"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      {/* Overlays */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#020B14]/97 via-[#020B14]/90 to-[#020B14]/75" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#020B14]/40 via-transparent to-[#020B14]/70" />
      {/* Top accent */}
      <div className="absolute top-0 left-0 right-0 h-[1.5px] bg-gradient-to-r from-transparent via-[#0EA5E9]/45 to-transparent" />

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6">

        {/* Two-column: copy left, actions right */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-14 items-center">

          {/* Left — copy */}
          <div className="lg:col-span-3">
            <div className="inline-flex items-center gap-2.5 bg-[#0EA5E9]/10 border border-[#0EA5E9]/30 rounded-full px-4 py-2 mb-8">
              <div className="w-1.5 h-1.5 rounded-full bg-[#38bdf8] animate-pulse flex-shrink-0" />
              <span className="font-['Inter'] text-[#7DD3FC] text-[11px] font-medium tracking-[0.18em] uppercase whitespace-nowrap">
                Same-Day &amp; Emergency Service Available
              </span>
            </div>
            <h2 className="font-['Playfair_Display'] text-white text-4xl md:text-5xl lg:text-[3rem] font-bold leading-[1.08] mb-6">
              {headline}
            </h2>
            <p className="font-['Inter'] text-white/85 text-base md:text-[1.05rem] leading-[1.82]">
              {subheadline}
            </p>
          </div>

          {/* Right — CTAs + trust */}
          <div className="lg:col-span-2 flex flex-col gap-4">
            <a
              href={ctaHref}
              className="inline-flex items-center justify-center gap-2.5 bg-[#0EA5E9] hover:bg-[#0284C7] text-white font-['Inter'] font-bold text-base px-10 py-4.5 py-[1.125rem] rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer shadow-[0_4px_28px_rgba(14,165,233,0.45)] hover:shadow-[0_6px_34px_rgba(14,165,233,0.55)] hover:-translate-y-[1.5px]"
            >
              {ctaLabel}
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </a>
            <a
              href="tel:2148703185"
              className="inline-flex items-center justify-center gap-2.5 bg-white/8 hover:bg-white/14 border border-white/20 hover:border-white/35 text-white font-['Inter'] font-semibold text-base px-8 py-4 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                <i className="ri-phone-fill text-[#7DD3FC] text-sm"></i>
              </div>
              Call 214-870-3185
            </a>

            {/* Trust row */}
            <div className="flex flex-col gap-2.5 mt-2 pt-5 border-t border-white/18">
              {[
                { icon: "ri-shield-check-fill", text: "Licensed & Insured" },
                { icon: "ri-star-fill", text: "5-Star Rated Service" },
                { icon: "ri-map-pin-2-line", text: "McKinney & Dallas Metro" },
              ].map((s) => (
                <div key={s.text} className="flex items-center gap-2.5">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className={`${s.icon} text-[#7DD3FC] text-xs`}></i>
                  </div>
                  <span className="font-['Inter'] text-white/80 text-xs whitespace-nowrap">{s.text}</span>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
